import { lazy, type ReactNode } from 'react'

export { newsletterStyles } from './styles'

const FebruaryNewsletter = lazy(() => import('./feb-2026'))
const MarchNewsletter = lazy(() => import('./mar-2026'))
const AprilNewsletter = lazy(() => import('./apr-2026'))
const MayNewsletter = lazy(() => import('./may-2026'))

export type NewsletterEntry = {
  key: string
  label: string
  render: () => ReactNode
}

// Ordenados cronológicamente: el último se muestra por defecto.
// Cada newsletter se descarga bajo demanda (lazy) al navegar a él.
export const NEWSLETTERS: NewsletterEntry[] = [
  { key: 'feb-2026', label: 'febrero 2026', render: () => <FebruaryNewsletter /> },
  { key: 'mar-2026', label: 'marzo 2026', render: () => <MarchNewsletter /> },
  { key: 'apr-2026', label: 'abril 2026', render: () => <AprilNewsletter /> },
  { key: 'may-2026', label: 'mayo 2026', render: () => <MayNewsletter /> },
]
